import React from "react";
import {Stepper} from "@chakra-ui/react";
import {IStepperStep} from "../../models/interfaces/steperItem.interface.ts";
import StepperStep from "../StepperStep.tsx";


interface CreateProjectStepsProps {
  steps: IStepperStep[];
  activeStep: number;
}

const CreateProjectSteps: React.FC<CreateProjectStepsProps> = (
  {
    steps,
    activeStep,
  }: CreateProjectStepsProps) => {

  return (
    <Stepper
      index={activeStep}
      className="mb-6"
      colorScheme="brandPurple.500"
    >
      {steps.map((step: IStepperStep, index: number) => (
        <StepperStep
          key={index}
          step={step}
          isCompleted={index < activeStep}
          isActive={index === activeStep}
        />
      ))}
    </Stepper>
  )
}

export default CreateProjectSteps;
